// Turns free text from the API (room/venue/hall descriptions, which contain
// raw line breaks and run 250–350+ characters) into a meta/og description:
// whitespace collapsed to single spaces, cut at a word boundary to fit
// within `max` characters, with an ellipsis when shortened.
export function toMetaDescription(text, max = 160) {
  if (!text) return text;
  const clean = String(text).replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).replace(/[\s,.;:–-]+$/, '')}…`;
}
